var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
let EditableTextarea = class EditableTextarea extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = false;
        this.isSuccess = false;
        this.isError = false;
        // #endregion
        // #region Async methods
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    onInput(text) {
        this.$emit('input', {
            value: text,
            setLoading: this.setLoading,
            setSuccess: this.setSuccess,
            setError: this.setError,
        });
    }
    setLoading(state) {
        this.isLoading = state;
    }
    setSuccess(state) {
        this.isError = false;
        this.isSuccess = state;
    }
    setError(state) {
        this.isSuccess = false;
        this.isError = state;
    }
};
EditableTextarea = __decorate([
    Component({
        components: {
        //
        },
    })
], EditableTextarea);
export default EditableTextarea;
